<template>
    <div>
        <form v-if="!success" class="p-3 sm:p-1" ref="form" @submit.prevent="submit">

            <div class="bg-gray-100 pt-5 pb-1">
                <div class="md:w-4/5 w-full mx-auto mb-12">
                    <div class="w-full max-w-lg mx-auto flex mb-6 justify-between">
                        <h1 class="block text-2xl">Pick a plan</h1>
                        <div class="flex content-center items-center">
                            <span class="text-xs inline-block pr-2 text-gray-600">Monthly</span> <switch-button @click.native="toggleInterval" :on="switchOn"></switch-button> <span class="text-xs inline-block pl-2 text-gray-600">Yearly</span>
                        </div>
                    </div>

                    <div class="flex flex-wrap mb-4">
                        <div v-for="plan in plans" class="md:w-1/4 w-full p-2">
                            <div class="border-2 border-solid h-auto rounded overflow-hidden cursor-pointer" :class="{ 'mt-6' : !plan.featured, 'border-solid border-black': plan.monthly_plan_id === selected_plan || plan.yearly_plan_id === selected_plan }" @click="changePlan(showInterval === 'yearly' ? plan.yearly_plan_id : plan.monthly_plan_id)">
                                <div v-if="plan.featured" class="h-6 text-center text-xs border-solid py-1 text-white bg-green-600">Most Popular</div>
                                <div class="text-center text-lg border-solid py-2 border-b" :class="{ 'font-black' : plan.featured }">
                                    <radio-icon :selected="plan.monthly_plan_id === selected_plan || plan.yearly_plan_id === selected_plan"></radio-icon>
                                    {{ plan.name }}
                                </div>
                                <div class="p-2">
                                    <p v-if="showInterval === 'monthly'" class="text-lg font-bold">${{ plan.monthly_price }}/mo</p>
                                    <p v-if="showInterval === 'yearly'" class="text-lg font-bold">${{ plan.annual_price }}/mo</p>
<!--                                    <ul class="text-xs">-->
<!--                                        <li v-if="showInterval === 'monthly'">{{ plan.monthly_price_yearly_total }}</li>-->
<!--                                        <li v-if="showInterval === 'yearly'">{{ plan.yearly_price_by_month_total }}</li>-->
<!--                                    </ul>-->
                                    <p class="text-sm">{{ numberWithCommas(plan.monthly_limit) }} requests/mo</p>
                                </div>
                                <div class="text-center text-sm border-solid py-2 border-t">5 day free trial</div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full max-w-lg mx-auto">

                <h2 class="pt-3 block text-xl mb-6">Login Information</h2>

                <div class="flex flex-wrap -mx-3 mb-6">
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <label class="label" for="grid-first-name">
                            Name
                        </label>
                        <input v-model="name" class="input focus:outline-none focus:shadow-outline" id="grid-first-name" type="text" placeholder="Jane" required>
                        <!--                        <p class="text-red-500 text-xs italic">Please fill out this field.</p>-->
                    </div>
                    <div class="w-full md:w-1/2 px-3">
                        <label class="label" for="grid-email">
                            Email
                        </label>
                        <input v-model="email" class="input focus:outline-none focus:shadow-outline" id="grid-email" type="email" placeholder="email@example.com" required>
                    </div>
                </div>
                <div class="flex flex-wrap -mx-3 mb-12">
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <label class="label" for="grid-password">
                            Password (10+ characters)
                        </label>
                        <input v-model="password" class="input focus:outline-none focus:shadow-outline" id="grid-password" type="password" placeholder="••••••" required>
                        <!--                        <p class="text-red-500 text-xs italic">Please fill out this field.</p>-->
                    </div>
                    <div class="w-full md:w-1/2 px-3">
                        <label class="label" for="grid-password-confirm">
                            Password Again
                        </label>
                        <input v-model="password_confirm" class="input focus:outline-none focus:shadow-outline" id="grid-password-confirm" type="password" placeholder="••••••" required @blur="comparePasswords">
                    </div>
                </div>

            </div>

            <div class="border border-solid p-5 rounded w-full max-w-lg mx-auto mb-6">
                <label class="label" for="coupon" :class="{ 'success': couponCode !== '' }">
                    Coupon <span v-show="couponCode !== ''">Applied ({{ couponAmount }})</span>
                </label>
                <div class="flex" :class="{ 'mb-3': addCouponCodeMessage !== '' }">
                    <div class="mr-5 w-3/4">
                        <input id="coupon" ref="couponField" class="mb-0 input focus:outline-none focus:shadow-outline" :disabled="couponCode !== ''" style="margin-bottom: 0" type="text" placeholder="Coupon Code">
                    </div>
                    <button type="button" @click="applyCoupon" :disabled="processing" class="w-1/4 text-sm text-gray-800 border border-gray-500 hover:bg-gray-200 md:px-4 rounded" title="apply coupon">{{ couponButtonTitle }}</button>
                </div>
                <div v-if="addCouponCodeMessage" class="text-sm rounded border-2 border-solid border-red-600 bg-red-100 text-red-400 p-3 mb-4">
                    {{ addCouponCodeMessage }}
                </div>
            </div>

            <div class="border-2 border-solid p-5 rounded w-full max-w-lg mx-auto mb-6">

                <h2 class="block text-xl mb-6"><lock-icon></lock-icon> Enter payment information</h2>

                <div class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white">
                    <div ref="card"></div>
                </div>

                <p class="text-gray-700 text-xs">You will pay ${{ agreeToPayAmount }} after your 5 day free trial. During those 5 days you can cancel without being billed.</p>

            </div>

            <div class="w-full max-w-lg mx-auto">

                <div class="w-full mb-4 text-xs">
                    <input type="checkbox" v-model="agree" value="1" id="terms" class="inline-block mr-2" required> <label for="terms" class="text-gray-600">I agree to the <a href="/privacy" class="text-blue-500 underline" target="_blank">Privacy</a> and <a href="/terms" class="text-blue-500 underline" target="_blank">Terms</a></label>
                </div>

                <div v-if="errors.length" class="text-sm rounded border-2 border-solid border-red-600 bg-red-100 text-red-400 p-3 mb-4">
                    <ul>
                        <li v-for="item in errors">{{ item }}</li>
                    </ul>
                </div>

                <button :disabled="submitDisabled" type="submit" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                    {{ submitButtonText }}
                </button>
            </div>

        </form>

        <div v-if="success" class="text-center mt-5 sm:p-1">You're signed up! Get started with the <a href="/docs">docs</a>! <a href="/login">Login</a> at any time to manage your subscription.</div>
    </div>
</template>

<script>
    import RadioIcon from "./RadioIcon"
    import SwitchButton from "./SwitchButton"
    import EventBus from "../event-bus"
    import LockIcon from "./LockIcon"
    export default {
        name: "Subscribe",
        components: {
            RadioIcon,
            SwitchButton,
            LockIcon
        },
        data () {
            return {
                name: '',
                email: '',
                password: '',
                password_confirm: '',
                token: null,
                selected_plan: null,
                response: {},
                processing: false,
                success: false,
                cardElement: null,
                plans: window.plans,
                agree: 0,
                showInterval: 'yearly',
                card_errors: '',
                error_messages: [],
                default_monthly_plan: '',
                default_yearly_plan: '',
                couponCode: '',
                couponAmount: '',
                addCouponCodeMessage: ''
            }
        },
        computed: {
            couponButtonTitle ()
            {
                if(this.couponCode !== '')
                {
                    return 'Remove';
                }

                return 'Apply';
            },
            submitDisabled () {
                return this.processing;
            },
            submitButtonText () {
                return this.processing ? 'Processing...' : 'Subscribe';
            },
            switchOn()
            {
                return this.showInterval === 'yearly';
            },
            errors(){
                let errors = [];

                if(this.card_errors)
                {
                    errors.push(this.card_errors);
                }

                if(this.error_messages)
                {
                    errors.push(...this.error_messages);
                }

                return errors;
            },
            agreeToPayAmount()
            {
                if(this.selected_plan === null)
                {
                    return '';
                }

                let total = '';

                const planKey = this.showInterval === 'yearly' ? 'yearly_plan_id' : 'monthly_plan_id';

                const plan = this.plans.find(p => p[planKey] === this.selected_plan);

                if(this.showInterval === 'monthly')
                {
                    total = plan.monthly_price;
                }
                else
                {
                    total = plan.yearly_price_by_month_total;
                }

                const interval = this.showInterval === 'yearly' ? 'year' : 'month';

                return `${total}${this.couponCode !== '' ? ' (Before '+this.couponAmount+')' : ''} per ${interval}`
            }
        },
        mounted: function () {
            const elements = window.stripe.elements();

            this.cardElement = elements.create('card');
            this.cardElement.mount(this.$refs.card);

            this.plans = plans.map(plan => {
                if(plan.id === 3)
                {
                    plan.featured = true;
                }
                else
                {
                    plan.featured = false;
                }
                return plan;
            });

            const defaultPlan = this.plans.find(plan => {
                return plan.featured === true;
            });

            this.selected_plan = defaultPlan.yearly_plan_id;
            this.default_yearly_plan = defaultPlan.yearly_plan_id;
            this.default_monthly_plan = defaultPlan.monthly_plan_id;

            EventBus.$on('interval-changed', this.intervalChanged);

            const self = this;
            this.cardElement.addEventListener('change', (error) => {
                self.card_errors = error.message;
            });
        },
        methods: {
            applyCoupon ()
            {
                if(this.couponCode !== '')
                {
                    this.couponCode = '';
                    this.couponAmount = '';
                    this.$refs.couponField.value = '';
                    return;
                }

                const self = this;
                self.processing = true;
                self.addCouponCodeMessage = '';

                window.axios.post('coupon', {couponCode: self.$refs.couponField.value}).then(response => {
                    if(response.data.success)
                    {
                        self.couponCode = response.data.couponCode;
                        self.couponAmount = response.data.couponAmount;
                    }
                    else
                    {
                        self.addCouponCodeMessage = response.data.message;
                    }
                }).catch(error => {
                    console.log(error);
                    self.addCouponCodeMessage = error.response.data.message;

                }).finally(() => {
                    self.processing = false;
                });
            },
            changePlan (plan) {
                console.log(plan);
                this.selected_plan = plan;
            },
            submit: function(event)
            {
                const self = this;
                self.processing = true;
                self.error_messages = [];
                self.card_errors = '';

                this.comparePasswords();

                let data = {
                    name: self.name,
                    email: self.email,
                    password: self.password,
                    password_confirm: self.password_confirm,
                    payment_method: null,
                    plan: self.selected_plan,
                    agree: self.agree,
                    couponCode: self.couponCode
                };

                try {
                    if(self.card_errors)
                    {
                        throw new Error('Card details need help');
                    }

                    stripe.createPaymentMethod('card', self.cardElement).then(function(result) {
                        // Access the token with result.token
                        data.payment_method = result.paymentMethod.id;

                        window.axios.post('/subscribe', data).then(response => {
                            self.response = response.data;
                            if(self.response.success)
                            {
                                self.success = true;
                            }
                        }).catch(error => {
                            console.log(error);
                            self.error_messages.push(error.response.data.message);
                        });

                    }).catch(function(error) {
                        // TODO set the error
                        console.log('we had a tokenization error');
                        console.dir(error);
                    });
                } catch (e)
                {
                    //
                } finally {
                    self.processing = false;
                }

            },
            toggleInterval() {
                // reset selection
                this.selected_plan = null;
                this.showInterval = this.showInterval === 'monthly' ? 'yearly' : 'monthly';
                this.selected_plan = this.showInterval === 'yearly' ? this.default_yearly_plan : this.default_monthly_plan;
                console.log(this.selected_plan);
            },
            numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            /**
             * Handle event from SwitchButton
             */
            intervalChanged(currentValue) {
                console.log(currentValue);
                this.showInterval = currentValue === true ? 'yearly' : 'monthly';
                this.selected_plan = this.showInterval === 'yearly' ? this.default_yearly_plan : this.default_monthly_plan;
                console.log(this.selected_plan);
            },

            comparePasswords() {
                if(this.password !== this.password_confirm)
                {
                    this.error_messages.push('Your passwords do not match');
                }
            }
        },
        beforeDestroy() {
            this.cardElement.removeEventListener();
        }
    }
</script>

<style scoped>

</style>
